// extracted by mini-css-extract-plugin
export var chevronIcon = "_d9-2";
export var teamName = "_d9-1";
export var teamSwitcherButton = "_d9-0";